<template>
    <app-content-admin>
        <template slot="header">AdPlacement</template>
        <template>
            <v-row align="center">
                <v-col cols="10">
                    <v-text-field
                        v-model="searchTerm"
                        label="Placement Name"
                        outlined
                        clearable
                        solo-inverted
                        full-width
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="placementListData" class="ma-2"
                        >Search</v-btn
                    >
                </v-col>
            </v-row>
        </template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="primary"
                to="/adplacement/add_adplacement"
            >
                + Add AdPlacement
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">Id</th>
                            <th scope="col">Name</th>
                            <th scope="col">Description</th>
                            <th scope="col">Active</th>
                            <th scope="col">Rotate Max</th>
                            <th scope="col">Action</th>
                            <th scope="col">Zone Names</th>
                        </thead>

                        <tbody>
                            <tr
                                class="text-center"
                                v-for="(adplacement, i) in displayedItems"
                                :key="i"
                            >
                                <td :data-label="$t('Id')">
                                    {{
                                        adplacement.placement_data.placement_id
                                    }}
                                </td>
                                <td
                                    :data-label="$t('Name')"
                                    class="text-truncate"
                                >
                                    {{
                                        adplacement.placement_data
                                            .placement_name
                                    }}
                                </td>
                                <td
                                    :data-label="$t('Description')"
                                    class="text-truncate"
                                >
                                    {{
                                        adplacement.placement_data
                                            .placement_description
                                    }}
                                </td>
                                <td :data-label="$t('Active')">
                                    <v-switch
                                        v-model="
                                            adplacement.placement_data
                                                .placement_active
                                        "
                                        :disabled="true"
                                    ></v-switch>
                                </td>
                                <td :data-label="$t('Rotate Max')">
                                    {{
                                        adplacement.placement_data
                                            .placement_rotate_max
                                    }}
                                </td>

                                <td :data-label="$t('action')">
                                    <v-menu
                                        :close-on-content-click="true"
                                        :nudge-width="200"
                                        :open-on-click="true"
                                        offset-y
                                        offset-x
                                        left
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="primary"
                                                text
                                                small
                                                icon
                                                v-on="on"
                                            >
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                @click="
                                                    ViewAdPlacementDetail(
                                                        adplacement
                                                            .placement_data
                                                            .placement_id
                                                    )
                                                "
                                            >
                                                <v-list-item-action>
                                                    Edit
                                                </v-list-item-action>
                                            </v-list-item>

                                            <v-list-item
                                                @click="
                                                    selectAdPlacementToDelete(
                                                        adplacement
                                                            .placement_data
                                                            .placement_id
                                                    )
                                                "
                                                v-if="isRole == 'admin'"
                                            >
                                                <v-list-item-action>
                                                    Delete
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>

                                <!-- -->

                                <td :data-label="$t('Zone Name')">
                                    <div>
                                        <div
                                            v-if="
                                                adplacement.relatedZoneNames &&
                                                adplacement.relatedZoneNames
                                                    .length > 0
                                            "
                                        >
                                            {{
                                                showZoneNames[
                                                    adplacement.placement_data
                                                        .placement_id
                                                ]
                                                    ? adplacement.relatedZoneNames.join(
                                                          ", "
                                                      )
                                                    : adplacement.relatedZoneNames
                                                          .slice(0, 3)
                                                          .join(", ")
                                            }}
                                            <span
                                                v-if="
                                                    adplacement.relatedZoneNames
                                                        .length > 3
                                                "
                                                @click="
                                                    toggleShowZoneNames(
                                                        adplacement
                                                            .placement_data
                                                            .placement_id
                                                    )
                                                "
                                                style="
                                                    cursor: pointer;
                                                    color: blue;
                                                "
                                            >
                                                ...
                                                {{
                                                    showZoneNames[
                                                        adplacement
                                                            .placement_data
                                                            .placement_id
                                                    ]
                                                        ? "Less"
                                                        : "More"
                                                }}
                                            </span>
                                        </div>
                                        <div v-else>No Zones</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Confirmation Dialog -->
                    <v-dialog v-model="showConfirmationDialog" max-width="400">
                        <v-card>
                            <v-card-title>Confirm Deletion</v-card-title>
                            <v-card-text>
                                Are you sure you want to delete this placement?
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="primary"
                                    @click="
                                        deletePlacement(adPlacementToDelete)
                                    "
                                >
                                    Yes
                                </v-btn>
                                <v-btn @click="cancelDelete()">No</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
                <v-pagination
                    class="pagination mb-2"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="updatePage"
                    :total-visible="7"
                ></v-pagination>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            adplacements: [],
            form: {
                page: 1,
                offset: 10,
            },
            itemsPerPage: 10,
            currentPage: 1,

            showDialog: false,
            showConfirmationDialog: false, // Initialize to false
            adPlacementToDelete: null, // Store the selected user for deletion
            placementRotateTime: 0,
            isRole: null,
            searchTerm: "",
            searchResult: [],

            showZoneNames: {},
        };
    },

    components: { ActiveLabel },

    computed: {
        totalPages() {
            return Math.ceil(this.adplacements.length / this.itemsPerPage);
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            console.log(endIndex);
            return this.adplacements.slice(startIndex, endIndex);
        },
    },

    created() {
        this.placementListData();
        this.isRole = this.$store.getters["auth/role"];
    },

    methods: {
        //Pagination
        updatePage(page) {
            this.currentPage = page;
        },

        onListChange(page) {
            this.placementListData(10, page);
        },

        //Read all placement data
        placementListData() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_placement_list/`, {
                    params: {
                        search_term: this.searchTerm,
                    },
                })
                .then((res) => res.data)
                .then((res) => {
                    this.adplacements = res.result.map((item) => {
                        return {
                            placement_data: item.placement,
                            relatedZoneNames: item.zones.map(
                                (zone) => zone.zone_name
                            ),
                        };
                    });
                })

                .catch((e) => {
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

        //Delete Specific Placement data
        async deletePlacement(id) {
            let loader = this.$loading.show();

            try {
                let res = await axios.post(`/api/auth/delete_placement`, {
                    placement_id: id,
                });

                // Log the response for debugging
                console.log("Delete Adplacement API Response:", res);

                if (res.data) {
                    this.$toastr.s("Delete successfully");
                    this.cancelDelete();
                    this.$router.push({ path: "/adplacement" });
                }
            } catch (e) {
                console.error("Error deleting adplacement:", e);

                this.$toastr.e(e.message);
            } finally {
                loader.hide();
                this.placementListData();
            }
        },

        //Read specific placement data
        ViewAdPlacementDetail(id) {
            console.log("Current placement id:", id);
            this.$router.push({ path: "/adplacement/view_adplacement/" + id });
        },

        //Delete placement diaolog function

        //Open Delete Dialog ui to pop out
        selectAdPlacementToDelete(id) {
            // Store the user data to delete
            this.adPlacementToDelete = id;
            // Open the confirmation dialog
            this.showConfirmationDialog = true;
        },

        //Close Delete Dialog
        cancelDelete() {
            this.showConfirmationDialog = false;
            this.adPlacementToDelete = null;
        },

        //more or less zone name dropdown control
        // more or less zone name dropdown control for specific adplacement
        toggleShowZoneNames(placementId) {
            this.$set(
                this.showZoneNames,
                placementId,
                !this.showZoneNames[placementId]
            );
        },
    },
};
</script>
